export default __webpack_public_path__ + "static/media/heart.6bf7a025.svg";